<template>
  <section class="text-content section text--dark">
    <div class="container">
      <p class="text-bold text--center text-content__title">Согласие на обработку персональных данных</p>
      <p>
        Настоящим я, действуя от своего имени, добровольно и не находясь под влиянием заблуждения, проставляя галочку напротив текста «Я
        предоставляю свое согласие на обработку персональных данных», и нажимая на кнопку отправки заполненной формы, даю свое согласие
        следующему оператору персональных данных: ООО «Смартлинк», ИНН 7813654235, ОГРН 1217800091134 (далее – «Оператор»); на
        автоматизированную, неавтоматизированную, смешанную обработку, включая сбор, запись, систематизацию, накопление, хранение, уточнение
        (обновление, изменение), извлечение, использование, передачу (предоставление, доступ), блокирование, удаление, уничтожение и
        передачу третьим лицам для проведения исследований, выполнения работ или оказания услуг, связанных с деятельностью Компании,
        следующих персональных данных:
      </p>
      <p>1. Общие категории персональных данных</p>
      <ul class="text-content__no-style">
        <li>1.1. Фамилия, имя, отчество.</li>
        <li>1.2. Контактный телефон.</li>
        <li>1.3. Адрес электронной почты.</li>
      </ul>
      <p>
        Срок действия настоящего согласия на обработку персональных данных начинается с момента его представления Оператору и прекращается
        по достижении целей обработки персональных данных или по получении отзыва согласия на обработку персональных данных. Настоящее
        согласие может быть отозвано путем направления Оператору соответствующего запроса по электронной почте
        <a href="mailto:info@terpo.ru" class="text-content__link">info@terpo.ru</a>. В этом случае Оператор прекращает обработку
        персональных данных, а персональные данные подлежат уничтожению, если отсутствуют иные правовые основания для обработки,
        установленные законодательством Российской Федерации.
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
definePageMeta({
  title: 'Согласие на обработку персональных данных',
});
</script>

<style lang="scss" scoped>
@import url('~/assets/styles/text-content.scss');
</style>
